import { useQueries, useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, getBatchFetcher } from '~/api/utils'
import type { ApplicantPicture } from '../types'

type ApplicantPictureWithId = ApplicantPicture & { id: number }

const applicantPicturesBatcher = () =>
  getBatchFetcher<ApplicantPictureWithId>('applicantPictures', async (ids) => {
    const pictures = await fetchApiWithToken<ApplicantPicture[]>({
      method: 'get',
      url: `/v1/applicants/profile_pics?id[]=${ids.join('&id[]=')}&itemsPerPage=1000&isArchived=all`
    })

    return pictures.map((picture) => {
      return {
        ...picture,
        id: picture.applicant.id
      }
    })
  })

export const useApplicantPictures = ({
  applicantIds
}: {
  applicantIds: number[]
}) => {
  return useQueries({
    queries: applicantIds.map((applicantId) => ({
      queryKey: ['applicants', 'picture', applicantId],
      queryFn: () => applicantPicturesBatcher().fetch(applicantId),
      staleTime: Number.POSITIVE_INFINITY,
      refetchOnWindowFocus: false
    }))
  })
}

export const useApplicantPicture = ({
  applicantId
}: {
  applicantId?: number
}) => {
  return useQuery({
    queryKey: ['applicants', 'picture', applicantId],
    queryFn: () =>
      applicantId
        ? applicantPicturesBatcher().fetch(applicantId)
        : Promise.resolve(null),
    enabled: !!applicantId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false
  })
}
